import { Component } from '@angular/core';
import {SIGNOFF} from '../../../common/core/common.constants';
import { OktaAuthorizationService } from 'src/app/services/okta-auth-service';
@Component({
  selector: 'app-sign-off',
  templateUrl: './sign-off.component.html',
  styleUrls: ['./sign-off.component.scss']
})
export class SignOffComponent {

  logout_name= SIGNOFF.LOGOUT_NAME;
  logout_content1= SIGNOFF.LOGOUT_CONTENT1;
  logout_content2= SIGNOFF.LOGOUT_CONTENT2;
  relogin= SIGNOFF.RELOGIN;

  constructor(public oktaAuth: OktaAuthorizationService) { }

  reLogin(){
    this.oktaAuth.logOutFromIAM();
  }

}
